/* istanbul ignore file */
import { Page404 } from 'framework/statusPages';
import { filterTruthy } from 'framework/utils';
import { Features, featureToggles } from 'infrastructure/featureToggle';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'react-router-dom';
import CandidateRouter from './candidate/CandidateRouter';
import CandidateDuplicateScanRouter from './candidate/duplicateScan/CandidateDuplicateScanRouter';
import VacancyGroupRouter from './newVacancy/VacancyGroupRouter';
import SalaryForksRouter from './salaryFork/SalaryForksRouter';
import { VacancyRouter } from './vacancy';
import { VacancyPublicationRouter } from './vacancy/publication';
import { ApplicationsRouter } from './applications';
import { ApplicationsRouter as CandidatesApplicationsRouter } from './candidatesApplications';
import PositionFillRequestsRouter from './positionFillRequests/PositionFillRequestsRouter';
import RecruitmentPoolRouter from './recruitmentPool/RecruitmentPoolRouter';

const candidatesApplicationsEnabled = Boolean(featureToggles[Features.CANDIDATES_APPLICATIONS]);
const positionFillRequestsEnabled = Boolean(featureToggles[Features.POSITION_FILL_REQUESTS_COLLECTION]);
const recruitmentPoolEnabled = Boolean(featureToggles[Features.RECRUITMENT_POOL]);

const RecruitingRouter = () => {
  const { isAuthenticated } = useAuthenticationService();

  return [
    <Route path={CandidateRouter.getRouterPath()} element={<CandidateRouter />} />,
    <Route path={CandidateDuplicateScanRouter.getRouterPath()} element={<CandidateDuplicateScanRouter />} />,
    <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
    <Route path={VacancyGroupRouter.getRouterPath()} element={<VacancyGroupRouter />} />,
    <Route path={SalaryForksRouter.getRouterPath()} element={<SalaryForksRouter />} />,
    <Route path={VacancyRouter.getRouterPath()} element={<VacancyRouter />} />,
    positionFillRequestsEnabled && (
      <Route path={PositionFillRequestsRouter.getRouterPath()} element={<PositionFillRequestsRouter />} />
    ),
    recruitmentPoolEnabled && (
      <Route path={RecruitmentPoolRouter.getRouterPath()} element={<RecruitmentPoolRouter />} />
    ),
    <Route path={VacancyPublicationRouter.getRouterPath()} element={<VacancyPublicationRouter />} />,
    <Route path={ApplicationsRouter.getRouterPath()} element={<ApplicationsRouter />} />,
    candidatesApplicationsEnabled && (
      <Route path={CandidatesApplicationsRouter.getRouterPath()} element={<CandidatesApplicationsRouter />} />
    ),
  ].filter(filterTruthy);
};

export default RecruitingRouter;
